import Unsplash from "unsplash-js";

const unsplash = new Unsplash({
  accessKey: "lH31SuTgtuA1gAFlireA6iYQZ6YRSrcn_1hzW_N4qVE",
  secret: "e4Zbv7wB9wxoOlZ9SyqDaVyUs7HB6VlsjGUlBfU89Mo"
});

export default unsplash;
